import logout from "../Global/logout";

export default async function resolver(promise, role) {
    const resolved = {
      data: null,
      error: null
    };

    try {
        resolved.data = await promise;  
        if(resolved.data.responseMessage) {
            logout(role)
        }
    } catch(e) {
        resolved.error = e;
    }
  
    return resolved;
  }